import { gql } from '@apollo/client';

export const AppSubscriptionFragment = gql`
  fragment AppSubscriptionFragment on AppSubscription {
    id
    user {
      id
      name
      email
      phone
      role
    }
  }
`;
